var ChatRole;
(function (ChatRole) {
    ChatRole["USER"] = "user";
    ChatRole["BOT"] = "bot";
    ChatRole["ASSISTANT"] = "assistant";
})(ChatRole || (ChatRole = {}));
var TypingMode;
(function (TypingMode) {
    TypingMode["AUTOPILOT"] = "autoPilot";
    TypingMode["USER"] = "user";
    TypingMode["BOT"] = "bot";
})(TypingMode || (TypingMode = {}));
var ConversationFlow;
(function (ConversationFlow) {
    ConversationFlow["GENERATE_MESSAGE"] = "GenerateMessage";
    ConversationFlow["GENERATE_CONVERSATION_IMAGE"] = "GenerateConversationImage";
    ConversationFlow["RATE_MESSAGE"] = "RateMessage";
    ConversationFlow["GET_MESSAGE"] = "GetMessage";
    ConversationFlow["UPDATE_MESSAGE"] = "UpdateMessage";
    ConversationFlow["DELETE_MESSAGE_IMAGE"] = "DeleteMessageImage";
})(ConversationFlow || (ConversationFlow = {}));
export { ChatRole, ConversationFlow, TypingMode };
